export default __webpack_public_path__ + "static/1249-7bf5f83059d966f54ab8b14eb774b42a.gif";